export const ACTIVATION_STATUS_ENUM = {
    ACTIVATED: { label: "Activé", value: "ACTIVATED"},
    DEACTIVATED: { label: "Désactivé", value: "DEACTIVATED" }
}